// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Menu-sidebar___I5nS{height:var(--size-full);padding-bottom:var(--bottom-bar-height);background-color:var(--surface-level-first)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": "Menu-sidebar___I5nS"
};
export default ___CSS_LOADER_EXPORT___;
